module.exports = __webpack_public_path__ + "static/img/qrcode_for.9bee9b57.jpg";